const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 30 * DAY;

function toMillis(input) {
    if (input == null) return null;
    if (typeof input === 'number') return input;
    if (typeof input === 'string') {
        const ms = Date.parse(input);
        return Number.isNaN(ms) ? null : ms;
    }
    if (typeof input === 'object' && typeof input.toMillis === 'function') {
        return input.toMillis();
    }
    if (input instanceof Date) return input.getTime();
    return null;
}

function pluralize(n, unit) {
    return `${n} ${unit}${n === 1 ? '' : 's'} ago`;
}

export function relativeTime(input, nowMs = Date.now()) {
    const ms = toMillis(input);
    if (ms == null) return '—';

    const diff = nowMs - ms;
    if (diff < MINUTE) return 'Active now';
    if (diff < HOUR) return pluralize(Math.floor(diff / MINUTE), 'minute');
    if (diff < DAY) return pluralize(Math.floor(diff / HOUR), 'hour');
    if (diff < 2 * DAY) return 'Yesterday';
    if (diff < WEEK) return pluralize(Math.floor(diff / DAY), 'day');
    if (diff < MONTH) return pluralize(Math.floor(diff / WEEK), 'week');
    return pluralize(Math.floor(diff / MONTH), 'month');
}
